import {actions} from './actions';
import {getters} from './getters';
import {mutations} from './mutations';
import {state} from './state';

export const report = {
  actions,
  getters,
  mutations,
  state,
  name: 'report'
};
